/*
 * Copyright (c) 2022 - Francisco Giana <gianafrancisco@gmail.com>
 */
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../_services';

@Injectable()
export class ComunicacionGuard implements CanActivate {

    constructor(private router: Router, private auth: AuthenticationService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // not logged in so redirect to login page
        if(this.auth.showComunicacion()){
            this.router.navigate(['/comunicacion']);
            return false;
        }
        return true;
    }
}
